<template>
  <a-config-provider :locale="locale">
    <router-view />

    <a-modal v-model:open="prompt.visible" :title="prompt.title" @ok="promptOk" @cancel="promptCancel">
      <div v-if="prompt.desc">{{ prompt.desc }}</div>
      <template v-if="prompt.type === 'dict'">

      </template>
      <template v-else-if="prompt.type === 'textarea'">
        <a-textarea v-model:value="prompt.value" :auto-size="{minRows: 5}" />
      </template>
      <template v-else>
        <a-input v-model:value="prompt.value" />
      </template>
    </a-modal>
  </a-config-provider>
</template>

<script>
import { mapGetters } from "vuex";
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import enUS from 'ant-design-vue/es/locale/en_US';

export default {
  data() {
    return {
      confirmValue: '',
    };
  },
  computed: {
    ...mapGetters(['prompt']),
    locale(){
      return this.$i18n.locale === 'zh' ? zhCN : enUS;
    }
  },
  methods: {
    promptOk() {
      if (typeof this.prompt.onOk === 'function') {
        const result = this.prompt.onOk(this.prompt.value);
        if(result instanceof Promise){
          result.then(() => this.prompt.visible = false).catch();
        }else if(result === undefined){
          this.prompt.visible = false;
        }else if(Boolean(result) === true ){
          this.prompt.visible = false;
        }
      }else{
        this.prompt.visible = false;
      }
    },
    promptCancel() {
      if (typeof this.prompt.onCancel === 'function') {
        this.prompt.onCancel(this.prompt.value);
      }
      this.prompt.visible = false;
    },
  },
  created() {
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

iframe {
  display: none;
}
</style>
